import React from 'react';
import { connect } from 'react-redux';
import { Trans } from 'react-i18next';
import { pageWrapper, EEventNames } from '../../../../../client/analytics';
import Container from '../../../../common/components/container';
import Overview from '../../../../common/components/overview';
import ComponentsForm from '../../forms/components';
import * as networkSelector from '../../selectors/network';
import * as organisationSelector from '../../../organisation/selectors/organisation';

const NetworkSettingsComponentsContainer = ({ network, organisation }) => (
  <Container name="SettingsAdmins">
    <Container.Content>
      <Overview>
        <Overview.Header>
          <Overview.Header.Title>
            <Trans i18nKey="network:settings_components_title" />
          </Overview.Header.Title>
        </Overview.Header>
        <Overview.Content>
          <ComponentsForm network={network} organisation={organisation} />
        </Overview.Content>
      </Overview>
    </Container.Content>
  </Container>
);

const mapStateToProps = (state) => ({
  network: networkSelector.selected(state),
  organisation: organisationSelector.selected(state),
});

export default connect(mapStateToProps)(
  pageWrapper(EEventNames.VISITED_NETWORK_COMPONENTS_SETTINGS_PAGE)(NetworkSettingsComponentsContainer)
);
